export const SERVER_URL = "https://do-calculate.com/api";

export const Period_EndPoint = "calculate-period";
export const Conception_EndPoint = "calculate-conception";
export const Ovulation_EndPoint = "calculate-ovulation";
export const DueDate_EndPoint = "calculate-due-date";
export const PregnancyConception_EndPoint = "calculate-pregnancy-conception";
export const WeightGainPregnancyCalculate_EndPoint =
  "calculate-pregnancy-weight-gain";
export const PregnancyCalculate_EndPoint = "calculate-pregnancy";
export const womenCalculators = [
  {
    name: "حاسبة الدورة الشهرية",
    link: "/calculator/ar/period/",
    description:
      "تساعد هذه الحاسبة في تتبع الدورة الشهرية وتحديد الفترات الخصبة.",
    showMain: true,
  },
  {
    name: "حاسبة الحمل",
    link: "/calculator/ar/pregnancy/",
    description:
      "تستخدم هذه الحاسبة لحساب موعد الحمل وتقدير أسبوع الحمل الحالي.",
    showMain: true,
  },
  {
    name: "حاسبة تاريخ الإخصاب خلال الحمل",
    link: "/calculator/ar/pregnancy-conception/",
    description: "تقوم هذه الحاسبة بحساب تاريخ الإخصاب أثناء فترة الحمل.",
    showMain: true,
  },
  {
    name: "حاسبة تاريخ الولادة المتوقعة",
    link: "/calculator/ar/pregnancy-due-date/",
    description:
      "تستخدم هذه الحاسبة لتقدير تاريخ الولادة المتوقع بناءً على تاريخ بدء الحمل.",
    showMain: true,
  },
  {
    name: "حاسبة التبويض",
    link: "/calculator/ar/ovulation/",
    description: "تساعد هذه الحاسبة في تقدير تاريخ التبويض وأفضل فترة للإخصاب.",
    showMain: true,
  },
  {
    name: "حاسبة تاريخ الإخصاب",
    link: "/calculator/ar/conception/",
    description:
      "تستخدم هذه الحاسبة لحساب تاريخ الإخصاب بناءً على تاريخ الدورة الشهرية ومدى دورتك الشهرية.",
    showMain: true,
  },
  {
    name: "حاسبة حجم حمالة الصدر",
    link: "/calculator/ar/bra_size_calculator/",
    description:
      "تستخدم هذه الحاسبة لحساب تاريخ الإخصاب بناءً على تاريخ الدورة الشهرية ومدى دورتك الشهرية.",
    showMain: true,
  },
];
export default womenCalculators;